'use client';

import {useEffect,useState} from 'react';
import {Heart} from 'lucide-react';

export default function LikeButton({targetId,label='喜欢'}:{targetId:string;label?:string}){
  const [likes,setLikes]=useState<number|null>(null),[busy,setBusy]=useState(false);
  useEffect(()=>{
    const controller=new AbortController();
    setLikes(null);
    fetch(`/api/community?id=${encodeURIComponent(targetId)}`,{signal:controller.signal,cache:'no-store'})
      .then(r=>r.json()).then(x=>setLikes(Number(x.likes)||0)).catch(()=>{});
    return()=>controller.abort();
  },[targetId]);

  const like=async()=>{
    if(likes===null||busy)return;
    setBusy(true);
    try{
      const response=await fetch('/api/community',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({action:'like',targetId})});
      const result=await response.json();
      if(response.ok&&Number.isFinite(Number(result.likes)))setLikes(Number(result.likes));
    }finally{setBusy(false)}
  };

  return <button className="hero-like" type="button" disabled={likes===null||busy} onClick={like} aria-busy={busy}>
    <Heart/>
    <span>{label}</span>
    <strong className="like-count">{likes===null?'—':likes}</strong>
  </button>;
}
